import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {
    state: {
        rules: [],
        selectedRule: undefined
    },
    mutations: {

        setRules (state, payload) {
            state.rules = payload
        },

        setSelectedRule (state, payload) {
            state.selectedRule = payload
        },
    },
    actions: {

        async addNewRule({ rootState }, payload) {
            
            let headerConfig = {
                headers: {
                    Authorization: `bearer ${rootState.User.userToken}`
                }
            }
            return await this.$http.post("/api/administrators/roles",payload, headerConfig)
                .then(response => {
                    if(response){
                        console.log(response)
                    }
                    return response;
                })
                .catch( error => {
                    return error;
                });
        },
        
        async loadRules({ commit, rootState }) {

            let headerConfig = {
                headers: {
                    Authorization: `bearer ${rootState.User.userToken}`
                }
            }
            return await this.$http.get("/api/administrators/roles", headerConfig)
                .then( response => {
                    commit("setRules", response.data.roles);
                    return response;
                })
                .catch( e => {
                    return e;
                });
        }

    },

    getters: {

        selectedRule (state) {
            return state.selectedRule;
        },

        rules (state) {
            return state.rules
        }
    }
};
